<template>
  <div class="likeSearch" v-wechat-title="$route.meta.title">
    <Header/>
    <BannerBg/>
    <div class="like_search_main">
      <div class="site_width_search">
        <div class="padding15">
          <div class="search_bar">
            <div class="width100">
              <div class="width4">
                <div class="padding_right15">
                  <select v-model="likeSearchParams.type" class="inputselect">
                    <option value=0>标题与正文</option>
                    <option value=1>仅搜索标题</option>
                  </select>
                </div>
              </div>
              <div class="width4">
                <div class="padding_right15">
                  <input v-model="likeSearchParams.name" class="inputselect" type="text" placeholder="关键字" value="关键字">
                </div>
              </div>
              <div class="width2">
                <input name="Submit4" type="button" class="search_btn_show input100" value="搜索" @click="onSubmit()">
              </div>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div class="search_result">
        <div class="site_width_search">
          <div class="width100 search_content">
            <div class="padding15">
              <div class="lawyer_int">
                <ul>
                  <li v-for="item in tableData" :key="item.id">
                    <a @click="contentToContent(item.id)">
                      <h2>{{ item.title }}</h2>
                      <span>{{ item.columnName }} <font>|</font>{{ formatDate(item.created) }}</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="pagination_box">
                <el-pagination
                  class="formPagination"
                  background
                  :pager-count="5"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="likeSearchParams.pageNo"
                  :page-size="likeSearchParams.pageSize"
                  layout="prev, pager, next"
                  :total="total">
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  export default {
    name: "likeSearch",
    data() {
      return {
        likeSearchParams: {
          type: 0,
          name: '',
          pageNo: 1,
          pageSize: 10
        },
        routeParams: {
          searchType: 0,
          searchName: '',
          columnId: 0,
          columnName: '首页',
          parentId: 0,
          pageNo: 1,
          pageSize: 10
        },
        total: 0,
        tableData: []
      }
    },
    mounted() {
      if (this.$route.params.name) {
        this.likeSearchParams.type = this.$route.params.searchType
        this.likeSearchParams.name = this.$route.params.searchName
        this.routeParams.searchType = this.$route.params.searchType
        this.routeParams.searchName = this.$route.params.searchName
        this.routeParams.columnName = this.$route.params.name
        this.routeParams.columnId = this.$route.params.id
        this.routeParams.parentId = this.$route.params.parentId
        window.sessionStorage.setItem('routeSearchParams', JSON.stringify(this.routeParams))
      } else if (!(window.sessionStorage.getItem('routeSearchParams') == null || window.sessionStorage.getItem('routeSearchParams') == undefined)){
        this.routeParams = JSON.parse(window.sessionStorage.getItem('routeSearchParams'))
        this.likeSearchParams.type = this.routeParams.searchType
        this.likeSearchParams.name = this.routeParams.searchName
      }
      if (this.$route.params.searchName) {
        this.getPageList()
      }
    },
    methods: {
      getPageList() {
        if (this.likeSearchParams.type == null) {
          this.likeSearchParams.type = 0
        }
        if (this.likeSearchParams.name == '') {
          this.$message.error("关键字不能为空！")
        } else {
          console.log(this.likeSearchParams)
          this.isLoading = true
          this.$axios.get(this.$apiUrl.LIKE_SEARCH_API_URL, 'Json', this.likeSearchParams)
          .then(res => {
            this.isLoading = false
            if (res.data.code == 200) {
              this.total = res.data.data.total
              this.tableData = res.data.data.list
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
              this.isLoading = false
              this.$message.error("服务器出现差错")
          })
        }
      },
      handleCurrentChange(pageNo) {
        this.likeSearchParams.pageNo = pageNo
        this.getPageList()
      },
      handleSizeChange(pageSize) {
        this.likeSearchParams.pageSize = pageSize
        this.getPageList()
      },
      contentToContent(id) {
        this.$router.push({
          name: "columnContent",
          params: {
            id: id,
            columnId: this.routeParams.columnId,
            columnName: this.routeParams.columnName,
            parentId: this.routeParams.parentId,
            fromLikeSearch: 1
          }
        })
      },
      formatDate(date) {
        if(date == undefined){
          return ''
        }
        return this.$moment(date).format("YYYY-MM-DD")
      },
      onSubmit() {
        this.getPageList()
      }
    }
  }
</script>
<style scoped lang="less">
  .el-pagination {
    text-align: center; 
  }
  .site_width_search{ max-width:1000px; margin:0 auto; position:relative; }
</style>